import CardApp from "../cardApp/cardApp";

const CardList = ({ applications }) => (
  <div className="app-grid">
    {applications.map((application) => (
      <CardApp key={application.id || application.slug} application={application} />
    ))}
  </div>
);

export default CardList;
